import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AgenciasService {
  @Output() idpaquete: EventEmitter<any> = new EventEmitter();
  httpHeaders = new HttpHeaders({
  });


  constructor(private http: HttpClient) { }

  changeIdPaquete(data: any) {
    this.idpaquete.emit(data);
  }

  totalVentasMes(): Observable<any>{
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/totalVentas',{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  totalNewUsers(): Observable<any>{
    const getRequest = new HttpRequest('GET', environment.api + 'api/user/totalNewUsers',{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  agenciasPendientes(limite: string): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/agency/list_pending?limite='+limite,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  agencias(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/agency/list_accepted',{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  agenciasFind(estado: string, texto: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("estado", estado);
    data.append("search", texto);
    const getRequest = new HttpRequest('POST', environment.api + 'api/agency/get',data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  aprobarAgencia(id: string):Observable<any> {
    const data: FormData = new FormData();
    data.append("id", id);
    const getRequest = new HttpRequest('POST', environment.api + 'api/agency/activate', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  aprobarAll(list: string[]):Observable<any> {

    const getRequest = new HttpRequest('POST', environment.api + 'api/agency/activateAll', list, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  rechazarAgencia(id: string):Observable<any> {
    const data: FormData = new FormData();
    data.append("id", id);
    const getRequest = new HttpRequest('POST', environment.api + 'api/agency/refuse', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  getAgencia(id: string):Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/agency/get?id='+id, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  getAgenciaUser():Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/agency/show', {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  update(id: string, agencia: string, email:string, vendedor:string, direccion: string,
    telefono: string, razonSoc: string, twitter: string, facebook: string, instagram: string, imagen: any): Observable<any> {
      const data: FormData = new FormData();
      data.append("id", id);
      data.append("name", agencia);
      data.append("email", email);
      data.append("vendedor", vendedor);
      data.append("direccion", direccion);
      data.append("telefono", telefono);
      data.append("facebook", facebook);
      data.append("twitter", twitter);
      data.append("instagram", instagram);
      data.append("razonSoc", razonSoc);
      data.append("imagen", imagen);


    const postRequest = new HttpRequest('POST', environment.api + 'api/agency/update',  data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);
  }

  //*** listado de paquetes reservados (presentes en reservaciones con estado 1)
  toursReservados(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/paquete/listImg',{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  UntourReservado(idPaquete: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/paquete/listImgId?id='+idPaquete,{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de reservaciones con al menos un pasajero sin confirmar
  reservacionesXPasajeroNC(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/porConfirmar', {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de reservaciones activas
  reservaciones(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/list?estado='+1, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de reservaciones confirmadas
  reservacionesConfirmadas(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/list?estado='+2, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de reservaciones asociadas a un paquete (agrupadas por agencias)
  reservacionesTour(idPaquete: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/list?paquete='+idPaquete, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de agencias asociadas a un paquete (resumido)
  agenciasPaquete(idPaquete: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/agenciasReservacion?paquete='+idPaquete, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de agencias asociadas a un paquete de acuerdo a filtros
  agenciasFiltradas(criterio: string, paquete: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("criterio", criterio);
    data.append("estado", estado);
    data.append("paquete", paquete);
    const postRequest = new HttpRequest('POST', environment.api + 'api/agency/filter', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(postRequest);
  }

  //*** listado de agencias asociadas a un paquete de reservacion confirmada (resumido)
  agenciasConfPaquete(idPaquete: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/agenciasConfReservacion?paquete='+idPaquete, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de pasajeros asociadas a un paquete (agrupados por agencias)
  agenciasTour(idAgencia: Number, idPaquetePasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/list?agencia='+idAgencia+'&paquete='+idPaquetePasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de pasajeros asociadas a un paquete (agrupados por agencias, y considerando el estado del pasajero)
  pasajerosTour(idAgencia: Number, idPaquetePasajero: Number, estadoPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/listPasajeros?agencia='+idAgencia+'&paquete='+idPaquetePasajero+'&estado='+estadoPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** planilla de un pasajero para tour reservado por agencia (busca por reservacion)
  pasajeroReservacion(idPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/get?id='+idPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }
  getDocumentos(idPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/getDocs?id='+idPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }
  deleteDocumento(id: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/deleteDocumento?id='+id, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }
  getFichas(idPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/getFichas?id='+idPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }
  deleteFicha(id: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/deleteFichaMedica?id='+id, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** cambia el estado de una reservacion
  confirmarReservacion(idReservacion: String): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/change?id='+idReservacion, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** aprueba un pasajero de una reservacion
  aprobarPasajero(idPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/change?id='+idPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** cancela un pasajero de una reservacion
  cancelarPasajero(idPasajero: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/pasajero/delete?id='+idPasajero, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** aprueba todos los pasajeros de una reservacion
  aprobarTodosPasajeros(pasajeros): Observable<any> {
    const data = {
      list: pasajeros,
    }
    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/changeEstados', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de paquetes confirmados
  toursConfirmados(): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/paquete/listImgCfm',{
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  //*** listado de confirmaciones asociadas a un paquete (agrupadas por agencias)
  confirmacionesTour(idPaquete: Number): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/reservacion/list?paquete='+idPaquete, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  /******Del usuario agencia */
  viajesReservadosAgencia(user: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/paquetesResAgencia', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  /******Del usuario admin */
  viajesReservados(estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/paquetesRes', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  viajesConfirmadosAgencia(user: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/paquetesResAgencia', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  paqueteFiltradoPorAgencia(user: string, criterio: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("criterio", criterio);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/paquete/paquetesSearch', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  /*************Pasajeros Reservados de una Agencia */
  pasajerosAgencia(user: string, paquete: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("paquete", paquete);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/getPasajerosAgencia', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajerosAgenciaSearch(user: string, search: string, estado: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("user", user);
    data.append("search", search);
    data.append("estado", estado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/getPasajerosAgenciaSearch', data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  pasajeroUpdate(idPaquete: Number, nombre: string, telefono: string, email: string, tipoDocumento: string,
                 numeroDocumento: string, observaciones: string, nombreEmergencia: string, telefonoEmergencia: string, facebook: string,
                 twitter: string, instagram: string, habitacion: string, pagado: string, documento: any, ficha: any, ): Observable<any> {

    const data: FormData = new FormData();
    for(let x = 0; x < documento.length; x++) {
      data.append("documento", documento[x].file);
    }
    for(let x = 0; x < ficha.length; x++) {
      data.append("ficha", ficha[x].file);
    }
    data.append("nombre", nombre);
    data.append("telefono", telefono);
    data.append("email", email);
    data.append("tipoDocumento", tipoDocumento);
    data.append("numeroDocumento", numeroDocumento);
    data.append("observaciones", observaciones);
    data.append("nombreEmergencia", nombreEmergencia);
    data.append("telefonoEmergencia", telefonoEmergencia);
    data.append("facebook", facebook);
    data.append("twitter", twitter);
    data.append("instagram", instagram);
    data.append("habitacion", habitacion);
    data.append("pagado", pagado);

    const getRequest = new HttpRequest('POST', environment.api + 'api/pasajero/update?id='+idPaquete, data, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }

  habitacionesPaquetePasajero(id): Observable<any> {
    const getRequest = new HttpRequest('GET', environment.api + 'api/paquete/getHabitacionesPaquetePasajero?id_pasajero='+id, {
      headers: this.httpHeaders,
      reportProgress: true,
    });
    return this.http.request(getRequest);
  }


}

